import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-2xl font-bold text-foreground-100" style={{ fontFamily: "var(--font-heading)" }}>
            内容分类
          </h2>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-900 border border-background-800/60 hover:border-primary-500/40 hover:bg-background-800/50 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-800 group-hover:bg-primary-500/10 transition-colors duration-300 mb-3">
                <i className={`${cat.icon} text-2xl text-foreground-400 group-hover:text-primary-400 transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-300 group-hover:text-foreground-100 transition-colors duration-200 mb-1">{cat.name}</span>
              <span className="text-xs text-foreground-600">{cat.articleCount} 篇</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}